;(function($, undefined){

    var rnn = window.rnn;

    function initExpandables() {
        $('.pillars-index')
        .on('click', '.expand', function (event) {
            event.preventDefault();
            $(this).closest('.expandable').addClass('expanded');
        })
        .on('click', '.collapse', function (event) {
            event.preventDefault();
            $(this).closest('.expandable').removeClass('expanded');
        });
    }

    // Initialise Simple Controls
    function initSimpleControls() {
        initExpandables();
    }

    rnn.modules.register('simpleControls', {
        init: initSimpleControls
    });

})(jQuery);
